import {
  Box,
  Button,
  Flex,
  Image,
  InfoCircleIcon,
  ListItem,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
  RadioButton,
  Text,
  TextButton,
} from '@modusign/design-system';
import { useState } from 'react';

import InOrderImage from './inOrder.png';
import OutOfOrderImage from './outOfOrder.png';

interface SigningProgressTypeSelectionCardProps {
  isInOrder: boolean | null;
  onChange(isInOrder: boolean): void;
}

export default function SigningProgressTypeSelectionCard({
  isInOrder,
  onChange,
}: SigningProgressTypeSelectionCardProps) {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  return (
    <>
      <Box className="Card Card--theme-editor" p={6}>
        <Box mb={4}>
          <Text fontWeight="medium">서명 진행 방법</Text>
        </Box>
        <Flex gap={4} mb={4}>
          <Flex alignItems="center" as="label" gap={2}>
            <RadioButton checked={!!isInOrder} onClick={() => onChange(true)} />
            <Text color="textNeutralSlightlyLight" fontWeight="medium" sx={{ cursor: 'pointer' }}>
              순서대로 서명
            </Text>
          </Flex>
          <Flex alignItems="center" as="label" gap={2}>
            <RadioButton checked={!isInOrder} onClick={() => onChange(false)} />
            <Text color="textNeutralSlightlyLight" fontWeight="medium" sx={{ cursor: 'pointer' }}>
              순서없이 서명
            </Text>
          </Flex>
        </Flex>
        <Flex
          alignItems="center"
          backgroundColor="notificationBackgroundNeutralBase"
          borderColor="notificationBorderNeutralBase"
          borderRadius="3px"
          borderStyle="solid"
          borderWidth="1px"
          height="44px"
          justifyContent="space-between"
          px={5}
          py={4}
        >
          <Flex alignItems="center">
            <InfoCircleIcon color="iconNeutralSlightlyDark" mr={2} mt="-4px" />
            <Text color="textNeutralSlightlyLight" fontSize="sm">
              {isInOrder ? '설정한 순서대로 서명 진행' : '순서에 관계없이 서명 진행'}
            </Text>
          </Flex>
          <TextButton display="flex" onClick={() => setIsInfoModalOpen(true)}>
            <Text fontSize="sm">자세히</Text>
          </TextButton>
        </Flex>
      </Box>
      {isInfoModalOpen && (
        <Modal isOpen={isInfoModalOpen} maxWidth="sm" onClose={() => setIsInfoModalOpen(false)}>
          <ModalTitle>{isInOrder ? '순서대로 서명' : '순서없이 서명'}</ModalTitle>
          <ModalContent>
            <Image
              height="200px"
              src={isInOrder ? InOrderImage : OutOfOrderImage}
              sx={{
                mb: 6,
              }}
            />
            <Box
              backgroundColor="boxBackgroundNeutralBase"
              borderColor="boxBorderNeutralBase"
              borderStyle="solid"
              borderWidth="1px"
              px={6}
              py={7}
              textAlign="left"
            >
              <Box as="ul">
                {isInOrder ? (
                  <>
                    <ListItem mb={1}>
                      <Text>서명자의 순서에 따라 서명을 진행합니다.</Text>
                    </ListItem>
                    <ListItem>
                      <Text>
                        이전 서명자가 서명을 완료해야, 그다음 서명자가 서명 할 수 있습니다.
                      </Text>
                    </ListItem>
                  </>
                ) : (
                  <>
                    <ListItem mb={1}>
                      <Text>모든 서명자에게 동시에 서명을 요청합니다.</Text>
                    </ListItem>
                    <ListItem>
                      <Text>서명자는 순서에 관계없이 서명할 수 있습니다.</Text>
                    </ListItem>
                  </>
                )}
              </Box>
            </Box>
          </ModalContent>
          <ModalFooter>
            <Button onClick={() => setIsInfoModalOpen(false)}>확인</Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
}
